module.exports = __webpack_public_path__ + "img/primar_2k2_icon.9837d56f.png";